function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0963 13.2753C18.9963 13.2753 19.7883 12.7827 20.1963 12.0378L24.4923 4.24022C24.5935 4.05811 24.6454 3.85271 24.6429 3.64436C24.6404 3.436 24.5836 3.23191 24.4781 3.05228C24.3726 2.87264 24.2222 2.7237 24.0415 2.62017C23.8609 2.51665 23.6565 2.46214 23.4483 2.46204H5.68835L4.56035 0.059082H0.636353V2.46204H3.03635L7.35635 11.5813L5.73635 14.5129C4.86035 16.1228 6.01235 18.0812 7.83635 18.0812H22.2363V15.6783H7.83635L9.15635 13.2753H18.0963ZM6.82835 4.86499H21.4083L18.0963 10.8724H9.67235L6.82835 4.86499ZM7.83635 19.2827C6.51635 19.2827 5.44835 20.3641 5.44835 21.6857C5.44835 23.0073 6.51635 24.0886 7.83635 24.0886C9.15635 24.0886 10.2363 23.0073 10.2363 21.6857C10.2363 20.3641 9.15635 19.2827 7.83635 19.2827ZM19.8363 19.2827C18.5163 19.2827 17.4483 20.3641 17.4483 21.6857C17.4483 23.0073 18.5163 24.0886 19.8363 24.0886C21.1563 24.0886 22.2363 23.0073 22.2363 21.6857C22.2363 20.3641 21.1563 19.2827 19.8363 19.2827Z",
  fill: "#D64D6F"
});
function SvgIconCartLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCartLine);
export default __webpack_public_path__ + "static/media/iconCartLine.7f16549d.svg";
export { ForwardRef as ReactComponent };